/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {

	// JSON取得用 =========================================================
	let tagList = [];
	let newsList = [];

	const tagsJpJson = () => `/ajax/news/tag_list.json`;
	const tagsEnJson = () => `/ajax/english/news/tag_list.json`;
	const newsJpJson = () => `/ajax/news/list.json`;
	const newsEnJson = () => `/ajax/english/news/list.json`;

	const newsProNextJpJson = () => `https://ssl4.eir-parts.net/V4Public/eir/7313/ja/announcement/announcement_29.js`;
	const newsProNextEnJson = () => `https://ssl4.eir-parts.net/V4Public/eir/7313/en/announcement/announcement_30.js`;

	const tagsKey = 'rt_bn_tags';
	const newsKey = 'rt_bn_news';
	const newsListSelector = '.mod-news-txt-list';

	let $path = window.location.pathname;

	const isEnglishPage = () => $path.startsWith('/english');

	const categoryAll = () => isEnglishPage() ? 'All' : 'すべて';
	const categoryNotice = () => isEnglishPage() ? 'Information' : 'お知らせ';
	const categoryIr = () => isEnglishPage() ? 'IR Information' : 'IR情報';
	const tagCategoryAll = () => isEnglishPage() ? 'All' : 'すべて';
	const tagIrKessan = () => isEnglishPage() ? 'Financial Results Information' : '決算情報';
	const tagIrKessanKey = 'ir-kessan';
	const tagIrSoukai = () => isEnglishPage() ? 'General meeting' : '総会関連';
	const tagIrSoukaiKey = 'ir-soukai';
	const tagIrSonota = () => isEnglishPage() ? 'Other IR Materials' : 'その他IR資料';
	const tagIrSonotaKey = 'ir-sonota';

	// ====================================================================
	// <ニュース一覧>JSON取得
	const getJson = async (lang, tagsKey, newsKey, categoryFilters = ['notice', 'ir']) => {
		const { tagList, newsList } = await Promise.all([
			fetch(isEnglishPage() ? tagsEnJson() : tagsJpJson()).then(res => res.json()),
			fetch(isEnglishPage() ? newsEnJson() : newsJpJson()).then(res => res.json()),
			fetch(isEnglishPage() ? newsProNextEnJson() : newsProNextJpJson()).then(res => res.text()).then(res => {
				let json = res.slice(25);
				json = json.slice(0, json.length - 2);
				return JSON.parse(json);
			}),
		]).then(([tagList, newsList, proNextNewsList]) => {
			const parsedTags = (tagList[tagsKey] || []).map((tag, i) => {
				return {
					category: 'notice',
					key: tag._key || '',
					label: tag.cf_nt_name_d || tag.cf_nt_name_d_en || '',
				}
			});

			const parsedNews = (newsList[newsKey] || []).map((news) => {
				return {
					category: 'notice',
					isPdf: news.rt_cf_n_attachment_file_icon_pdf !== null || news.rt_cf_n_url_icon_pdf !== null,
					isNew: news.rt_cf_n_icon_new !== null,
					fileSize: bytesToSize(news.rt_cf_n_attachment_file_size?.content || news.rt_cf_n_url_file_size?.content || 0),
					title: (news.rt_cf_n_title?.content || []).join(''),
					link: news.rt_cf_n_href?.href || '',
					target: news.rt_cf_n_href?.target || '_self',
					linkStyle: news.rt_cf_n_href?.style || '',
					linkClassList: (news.rt_cf_n_href?.class || '').split(' '),
					date: news.rt_cf_n_date?.content || '',
					year: (news.rt_cf_n_date?.datetime || '').slice(0, 4),
					tags: (news.cf_n_tags || []).map((tag) => {
						return {
							key: tag._key || '',
							label: tag.cf_nt_name_d || tag.cf_nt_name_d_en || '',
						}
					}),
					dt: new Date(news.rt_cf_n_date?.datetime || '0000-12-31'),
				}
			});

			const parsedProNextNews = (proNextNewsList['item'] || [])
				.filter((news) => {
					if ([
						'ir_material7',
						'ir_material1',
						'ir_material_for_fiscal_ym3',
						'ir_material8',
						'ir_material_for_fiscal_ym5',
					].includes(news.sub_type)) {
						return false;
					}
					return true;
				})
				.map((news) => {
					// only number from string
					const fileSize = news.file_size?.replace(/\D/g, '');
					const newsDate = new Date(news.date || '0000-12-31');

					// newsDateから30日以内の場合はnew
					const newFlgDate = new Date(news.date || '0000-12-31');
					newFlgDate.setDate(newFlgDate.getDate() + 30);

					let tag = { key: '', label: '' };
					if (
						news.news_type === 'yuho'
						||
						news.news_type === 'tanshin'
						|| [
							'ir_material_for_fiscal_ym1',
							'ir_material_for_fiscal_ym7',
							'ir_material_for_fiscal_ym9',
							'ir_material3',
							'ir_material_for_fiscal_ym4',
						].includes(news.sub_type)
					) {
						tag.key = tagIrKessanKey;
						tag.label = tagIrKessan();
					} else if (['announcement', 'announcement1'].includes(news.sub_type)) {
						tag.key = tagIrSoukaiKey;
						tag.label = tagIrSoukai();
					} else if (
						news.news_type === 'press'
						||
						news.news_type === 'pr'
						|| [
							'ir_material_for_fiscal_ym6',
							'ir_material7',
							'ir_material1',
							'ir_material2',
							'ir_material_for_fiscal_ym',
							'ir_material_for_fiscal_ym3',
							'ir_material8',
							'ir_material_for_fiscal_ym5',
						].includes(news.sub_type)
					) {
						tag.key = tagIrSonotaKey;
						tag.label = tagIrSonota();
					}


					return {
						category: 'ir',
						isPdf: news.type === 'pdf',

						isNew: new Date() < newFlgDate,

						fileSize: bytesToSize((fileSize || 0) * 1000),
						title: news.title || '',
						link: news.link,
						target: '_blank',
						linkStyle: '',
						linkClassList: [],
						date: news.format_date || '',

						year: (news.date || '').slice(0, 4),
						tags: tag.key ? [tag] : [],
						news_type: news.news_type,
						dt: newsDate,
					}
				});

			const set = new Set();
			parsedProNextNews.forEach((news) => {
				set.add(news.news_type);
			});

			const combinedNewsList = parsedNews.concat(parsedProNextNews);
			combinedNewsList.sort((a, b) => {
				return b.dt - a.dt;
			});


			const combinedTagList = [
				{ category: '', key: '', label: tagCategoryAll() },
				{ category: 'ir', key: tagIrKessanKey, label: tagIrKessan() },
				{ category: 'ir', key: tagIrSoukaiKey, label: tagIrSoukai() },
				{ category: 'ir', key: tagIrSonotaKey, label: tagIrSonota() },
				...parsedTags,
			];


			return {
				tagList: combinedTagList,
				newsList: combinedNewsList,
			};
		}).then(({ tagList, newsList }) => {
			// filter with tagList and newsList using categoryFilters
			const filteredTagList = tagList.filter((tag) => {
				if (tag.key === '') {
					return true;
				}
				return categoryFilters.includes(tag.category);
			});

			const filteredNewsList = newsList.filter((news) => {
				return categoryFilters.includes(news.category);
			});

			return {
				tagList: filteredTagList,
				newsList: filteredNewsList,
			};
		});
		return { tagList, newsList };
	}

	const getFilteredTagList = (tagList) => {
		const searchParams = new URLSearchParams(window.location.search);
		const pCategory = searchParams.get('p_category') || '';

		const filteredTagList = tagList
			.filter((tag) => {
				if (tag.key === '') {
					return true;
				}
				// categories
				return pCategory ? tag.category === pCategory : true;
			});

		return filteredTagList;

	}

	const getFilteredNewsList = (newsList) => {
		const limit = getLimit();
		const searchParams = new URLSearchParams(window.location.search);
		const pCategory = searchParams.get('p_category') || '';
		const pTag = searchParams.get('p_tag') || '';


		const filteredNewsList = newsList
			.filter((news) => {
				// categories
				return pCategory ? news.category === pCategory : true;
			})
			.filter((news) => {
				// tags
				return news.tags.filter((tag) => {
					return pTag ? tag.key === pTag : true;
				}).length > 0 || (!pTag && news.tags.length === 0);
			})
			.filter((news) => {
				// year
				return searchParams.get('p_year') ? news.year === searchParams.get('p_year') : true;
			})
			.filter((news, idx) => {
				// limit
				return limit ? idx < limit : true;
			});

		return filteredNewsList;
	}

	// Lang ==============================================================
	const getLang = () => {
		return isEnglishPage()
			? 'english'
			: '';
	}

	// limit ==============================================================
	const getLimit = () => {
		let limit = null;
		if (['/', '/index.html', '/english/', '/english/index.html'].includes(window.location.pathname)) {
			limit = 5;
		} else if (['/ir/', '/ir/index.html', '/english/ir/', '/english/ir/index.html'].includes(window.location.pathname)) {
			limit = FUNCTIONS.va.isMobile ? 3 : 10;
		} else if (['/news/', '/news/index.html', '/english/news/', '/english/news/index.html'].includes(window.location.pathname)) {
			const pYear = new URLSearchParams(window.location.search).get('p_year') || '';
			if (pYear === '') {
				limit = 30;
			}
		}

		return limit;
	}

	// Generate Elements ==============================================================
	const bytesToSize = (bytes) => {
		const kilobytes = bytes / 1024;
		const nf = new Intl.NumberFormat('en-US');
		return nf.format(kilobytes.toFixed(0)) + 'KB';
	}

	const generateYearDropDown = (newsList) => {
		const yearElem = document.querySelector('.js-news-yearList');

		if (!yearElem) {
			return;
		}
		yearElem.innerHTML = '';

		const pYear = new URLSearchParams(window.location.search).get('p_year') || '';

		const yearSet = new Set(newsList.map((news) => news.year));
		const yearArr = Array.from(yearSet).sort((a, b) => b - a);
		const option = document.createElement('option');
		option.textContent = isEnglishPage() ? 'Latest' : '最新';
		option.value = "";

		if (pYear === '') {
			option.selected = true;
		}

		yearElem.appendChild(option);

		yearArr.map((year) => {
			const option = document.createElement('option');
			option.textContent = year;
			option.value = year;
			if (pYear == year) {
				option.selected = true;
			}
			yearElem.appendChild(option);
		});
	}

	const generateNewsElement = (news) => {
		const newsElement = document.createElement('div');
		newsElement.classList.add('mod-news-txt-list-item', 'mod-spacer-32_24');

		newsElement.innerHTML = `
			<div class="mod-news-txt-list-item-top">
				<p class="mod-news-day">
					<!-- 年月日: .mod-news-day -->
				</p>
				<div class="mod-news-category">
					<!-- タグ: .mod-label -->
				</div>
				<p class="mod-news-new di_none">NEW</p>
			</div>
			<a href="" class="top-note-content-item">
				<span class="title">
					<!-- タイトル: .top-note-content-item span -->
				</span>
				<svg aria-hidden="true" class="di_none">
					<use xlink:href="/common/svg/sprite.svg#pdf" />
				</svg>
				<span class="file-size di_none"></span>
				<span class="_icon _blank di_none">
					<svg class="" aria-hidden="true">
								<use xlink:href="/common/svg/sprite.svg#blank"></use>
					</svg>
				</span>
			</a>
		`

		// 年月日
		newsElement.querySelector('.mod-news-day').textContent = news.date;

		// タグ
		news.tags.forEach((tag) => {
			const tagElement = document.createElement('p');
			tagElement.classList.add('mod-label');
			tagElement.textContent = tag.label;
			newsElement.querySelector('.mod-news-category').appendChild(tagElement);
		});

		// NEW アイコン
		if (news.isNew) {
			newsElement.querySelector('.mod-news-new').classList.remove('di_none');
		}

		// ニュース詳細リンク
		newsElement.querySelector('.top-note-content-item').href = news.link;
		newsElement.querySelector('.top-note-content-item').target = news.target;
		newsElement.querySelector('.top-note-content-item').style = news.linkStyle;
		news.linkClassList.forEach((className) => {
			if (className) {
				newsElement.querySelector('.top-note-content-item').classList.add(className);
			}
		});

		// タイトル
		newsElement.querySelector('.top-note-content-item span.title').textContent = news.title;

		// PDF アイコン
		if (news.isPdf) {
			newsElement.querySelector('.top-note-content-item svg').classList.remove('di_none');
			if (news.fileSize) {
				newsElement.querySelector('.top-note-content-item .file-size').textContent = '（' + news.fileSize + '）';
				newsElement.querySelector('.top-note-content-item .file-size').classList.remove('di_none');
			}
		}

		// ブランクアイコン
		if (!news.isPdf && (news.target === '_blank' || news.link.startsWith('http'))) {
			newsElement.querySelector('.top-note-content-item ._icon._blank').classList.remove('di_none');
		}

		return newsElement;
	}

	const generateTagsElement = (tag) => {
		const tagElement = document.createElement('a');
		tagElement.classList.add('mod-tag');

		const url = new URL(window.location.href);
		const currentPtag = url.searchParams.get('p_tag') || '';
		url.searchParams.set('p_tag', tag.key);

		const href = url.pathname + url.search;

		tagElement.textContent = tag.label;
		tagElement.href = href;

		if (currentPtag === tag.key) {
			tagElement.classList.add('current');
		}

		return tagElement;
	}

	const appendNewsElements = (newsList) => {
		const newsListElement = document.querySelector(newsListSelector);
		newsListElement.innerHTML = '';

		if (newsListElement) {
			if (newsList.length === 0) {
				const elem = document.createElement('div');
				// <div class="mod-news-txt-list-item-top">
				elem.classList.add('mod-news-txt-list-item', 'mod-spacer-32_24');
				elem.textContent = isEnglishPage() ? 'There is no corresponding news.' : '該当するニュースはございません。';
				newsListElement.appendChild(elem);
			} else {
				newsList.forEach((news) => {
					const elem = generateNewsElement(news);
					newsListElement.appendChild(elem);
				});
			}
		}
	}

	const appendTagsElements = (tagList) => {
		const tagsElement = document.querySelector('.mod-news-txt .mod-news-tag');
		if (tagsElement) {
			tagsElement.innerHTML = '';
			tagList.forEach((tag) => {
				tagsElement.appendChild(generateTagsElement(tag));
			});
		}
	}

	const setCurrentCategory = () => {
		const searchParams = new URLSearchParams(window.location.search);
		const pCategory = searchParams.get('p_category') || '';

		document.querySelectorAll('.mod-news-tab-item button').forEach((node) => {
			if (node.textContent === categoryNotice() && pCategory === 'notice') {
				node.parentElement.classList.add('current');
			} else if (node.textContent === categoryIr() && pCategory === 'ir') {
				node.parentElement.classList.add('current');
			} else if (node.textContent === categoryAll() && !pCategory) {
				node.parentElement.classList.add('current');
			} else {
				node.parentElement.classList.remove('current');
			}
		});

	}


	// init ==============================================================
	const addEventListener = () => {
		const tagsElements = document.querySelectorAll('.mod-news-txt .mod-news-tag');

		if (tagsElements) {
			const tagEvent = (e) => {
				if (e.target.classList.contains('mod-tag')) {
					e.preventDefault();
					const url = new URL(window.location.href);
					const targetUrl = new URL(e.target.href);
					url.searchParams.set('p_tag', targetUrl.searchParams.get('p_tag') || '');

					// push state
					window.history.pushState({}, '', url.search);

					initHtml();
				}
			};

			tagsElements.forEach((node) => {
				node.removeEventListener('click', tagEvent);
				node.addEventListener('click', tagEvent);
			});
		}

		const tabElements = document.querySelectorAll('.mod-news-tab-item button');
		if (tabElements) {
			const tabEvent = (e) => {
				e.preventDefault();

				const text = e.target.textContent;

				const category = text === categoryNotice() ? 'notice' : text === categoryIr() ? 'ir' : '';

				const url = new URL(window.location.href);
				url.searchParams.set('p_category', category);
				url.searchParams.delete('p_tag');

				// push state
				window.history.pushState({}, '', url.search);
				initHtml();
			};
			tabElements.forEach((node) => {
				node.removeEventListener('click', tabEvent);
				node.addEventListener('click', tabEvent);
			});
		}

		const yearListElement = document.querySelector('.js-news-yearList');
		if (yearListElement) {
			const yearListEvent = (e) => {
				const url = new URL(window.location.href);
				url.searchParams.set('p_year', e.target.value);

				// push state
				window.history.pushState({}, '', url.search);
				initHtml();
			};

			yearListElement.removeEventListener('change', yearListEvent);
			yearListElement.addEventListener('change', yearListEvent);
		}
	}

	const initHtml = () => {
		// カテゴリー
		setCurrentCategory();

		// タグ
		appendTagsElements(getFilteredTagList(tagList));

		// ニュース
		const filteredNewsList = getFilteredNewsList(newsList);
		generateYearDropDown(newsList);
		appendNewsElements(filteredNewsList);
	}

	const init = async () => {
		const lang = getLang();

		let categoryFilters = ['notice', 'ir'];
		if ([
			'/ir/',
			'/ir/index.html',
			'/english/ir/',
			'/english/ir/index.html',
		].includes(window.location.pathname)) {
			categoryFilters = ['ir'];
		}

		const jsonData = await getJson(lang, tagsKey, newsKey, categoryFilters);
		tagList = jsonData.tagList || [];
		newsList = jsonData.newsList || [];

		initHtml();

		// Event Listener
		addEventListener();
	}


	init();
})(window.FUNCTIONS);
